/**
 * 事件监听兼容处理
 * @param {*} evtTarget  事件监听目标
 * @param {*} evtName   事件名
 * @param {*} callback  回调函数
 * @param {*} options  相关参数设置
 */
export function addMonitor(
  evtTarget: Element | Window | Document,
  evtName: string,
  callback: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions
) {
  if ('attachEvent' in evtTarget) {
    return evtTarget.attachEvent(`on${evtName}`, callback);
  }
  return evtTarget.addEventListener(evtName, callback, options);
}

/**
 * 事件监听解绑兼容处理
 * @param {*} evtTarget  事件监听目标
 * @param {*} evtName   事件名
 * @param {*} callback  事件回调
 */
export function removeMonitor(
  evtTarget: Element | Window | Document,
  evtName: string,
  callback: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions
) {
  if ('attachEvent' in evtTarget) {
    return evtTarget.detachEvent(`on${evtName}`, callback);
  }
  return evtTarget.removeEventListener(evtName, callback, options);
}

/**
 * 判断是否支持pushState
 */
export function supportsPushState() {
  const ua = window.navigator.userAgent;
  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false;
  }
  return window.history && 'pushState' in window.history;
}

const perf = typeof window !== 'undefined' ? window.performance : null;
export const performanceTiming = (perf && perf.timing) || null;

export const pagehideEventName =
  'onpagehide' in window ? 'pagehide' : 'beforeunload';
